import { render, staticRenderFns } from "./LKProfileIndex.vue?vue&type=template&id=4a35fa24&"
import script from "./LKProfileIndex.vue?vue&type=script&lang=js&"
export * from "./LKProfileIndex.vue?vue&type=script&lang=js&"
import style0 from "./LKProfileIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports